export default {
  order: {
    getOrderList: ['get', '/reservations/orders'],
    confirmOrderSubmit: ['put', '/reservations/orders/:orderNo/confirm'],
    cancelOrderSubmit: ['put', '/reservations/orders/:orderNo/cancel'],
  },
};
